// import { useContext, useState, useEffect } from 'react';
// import { AuthContext } from '../../contexts/auth';
// import { toast } from 'react-toastify';

import { useState, useEffect } from 'react';
//import Axios from 'axios';
import { listarClientes  } from '../../services/apigateway';
import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';

import Globais from '../../components/Globais/Globais';
import Tabela from '../../components/Table/tabela';
import Comandos from '../../components/Comandos/comandos';
import Paginate from '../../components/Paginate/paginate';

export default function Clientes(){
  const [clientes, setClientes, ligaMenu ] = useState([]);
  const [clienteFiltrado, setClienteFiltrado] = useState([]);
  const [clientePaginado, setClientePaginado] = useState([]);

  const [loading, setLoading] = useState(true);
  //const [showMensagem, setShowMensagem] = useState(false);
  //const [detail, setDetail] = useState();

  const [coluna, setColuna] = useState();
  const [ordem, setOrdem] = useState('asc');

  const [currentPage, setCurrentPage] = useState(0);
  const [qtdPaginas, setQtdPaginas] = useState(0);
  const [qtdLinhas, setQtdLinhas] = useState(Globais.qtd_linhas); 

  const elementos = [
    {
      coluna: 'cod_cliente',
      cabecalho: 'Código', 
      alinhamento: 'tdtabela'
    },
    {
      coluna: 'idt_cliente',
      cabecalho: 'Identificador', 
      alinhamento: 'tdtabelaleft'
    },
    {
      coluna: 'nom_cliente',
      cabecalho: 'Nome', 
      alinhamento: 'tdtabelaleft'
    },
    {
      coluna: 'loc_cliente',
      cabecalho: 'Localidade', 
      alinhamento: 'tdtabelaleft'
    },
    {
      coluna: 'sit_cliente',
      cabecalho: 'Situação', 
      alinhamento: 'tdtabela'
    }, 
    {
      coluna: 'ação',
      cabecalho: 'Ação',
      alinhamento: 'tdtabela'
    }
  ];

  useEffect(() => {
      loadClientes();
      return() => {}
  }, []);

  async function loadClientes(){
    // const url = Globais.url_consulta
    // const tabela = "Tab_Clientes";
    // const campos = "cod_cliente, idt_cliente, nom_cliente, loc_cliente, sit_cliente";
    // const condicao = "";
    // const orderBy = "nom_cliente";    
    
    try {
      const response = await listarClientes();

      console.log("response em clientes.js: ", response);

      //let result = JSON.parse(response);
      //console.log("result em clientes.js: ", result);

      setClientes(response);
      // console.log('Result: ', result);

      let dados = filterClientes(response, '');
      setClienteFiltrado(dados);
   
      let qtdpag = Math.ceil(dados.length / qtdLinhas)
      setQtdPaginas(qtdpag);
  
      let datas = paginarClientes(dados, 0, qtdLinhas);
      setClientePaginado(datas);
      setLoading(false);
  
      // console.log('Cliente Paginado: ', clientePaginado);
      setQtdPaginas(qtdpag);
  
    } catch(err) {
      console.log(err);
    }

    setLoading(false);
  }

  function filterClientes(dados, texto) {
    let data = [];
    console.log("dados em clientes.js: ", dados);
    
    dados && dados.filter(item => {return item.nom_cliente.toLowerCase().includes(texto)}).map(dado => {
      data.push(dado)
    });

    return data; 
  }  
 
  function paginarClientes(dados, offSet, qtdLinhas) {
    const startIndex = offSet;
    const endIndex = offSet + Number(qtdLinhas);

    let data = dados;
    return data.slice(startIndex, endIndex)
  }

  function handleSearch(texto) {
    let dados = filterClientes(clientes, texto);
    setClienteFiltrado(dados);

    let qtdpag = Math.ceil(dados.length / qtdLinhas)
    setQtdPaginas(qtdpag); 

    let data = paginarClientes(dados, 0, qtdLinhas)
    setClientePaginado(data);  
    setCurrentPage(0);
    setColuna();
  }

  function handlePageClick({ selected: selectedPage }) { 
    let posicao = (selectedPage) * qtdLinhas;
    setCurrentPage(selectedPage); 

    let data = paginarClientes(clienteFiltrado, posicao, qtdLinhas);
    setClientePaginado(data); 
  } 

  function handleQtdLinhas(valor) {
    if (Number(valor) === 0) {
      valor = clienteFiltrado.length;
    }

    setQtdLinhas(valor);

    let qtdpag = Math.ceil(clienteFiltrado.length / valor)
    setQtdPaginas(qtdpag);

    let data = paginarClientes(clienteFiltrado, 0, valor);
    setClientePaginado(data); 

    setCurrentPage(0); 
  } 
    
  function handleSort(coluna) {
    // console.log('Coluna: ', coluna);
    // console.log('Ordem: ', ordem );
    let order = ordem;

    if (order === 'asc') {
      order = 'desc';
    } else {
      order = 'asc';
    }

    setColuna(coluna);
    setOrdem(order);

    const dataCopy = [...clienteFiltrado];

    dataCopy.sort((dataA, dataB) => {
      if (order === 'desc') {
        return dataA[coluna] > dataB[coluna] ? 1 : -1

      } else {
        return dataB[coluna] > dataA[coluna] ? 1 : -1
      }
    }); 

    setClienteFiltrado(dataCopy); 

    let data = paginarClientes(dataCopy, 0, qtdLinhas);
    setClientePaginado(data); 
    setCurrentPage(0); 
  }

  if (loading){
    return(
      <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
      
      <main>
        <Titulo tela={'Cadastro de Clientes'} />

        <section className='md:grid md:grid-cols-[minmax(175px,20%)_minmax(60%,80%)] grid-cols-1'>
          <Menu />
          <div className=''>
          <span>Buscando Clientes...</span>
        </div>
        </section>
      </main>
    </div>
    )
  }
 
  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
        
        <main>
          <Titulo 
            tela={'Cadastro de Clientes'} 
            destination='/clientes/inclusao/'
            permissao='CLIENTE_INCLUIR'
          />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
            <Menu />
            <div>  
              <Tabela
                entidade='Clientes' 
                dados={clientePaginado}
                elementos={elementos}
                handleSort={handleSort}
                sortedId={coluna}
                ordem={ordem}
                urlBase='/clientes'
              />

              {qtdPaginas > 1 ? (
                <div className='pagination-container'>
                  <Comandos 
                    linhas = {qtdLinhas}
                    handleQtdLinhas = {handleQtdLinhas}
                    qtdRegistros = {clienteFiltrado.length} 
                  />
                  
                  <Paginate
                    qtdPaginas={qtdPaginas}
                    handlePageClick={handlePageClick}
                    currentPage={currentPage}
                  />

                </div>
              ) : (
                <div className='pagination-container'>
                  <Comandos 
                    linhas = {qtdLinhas}
                    handleQtdLinhas = {handleQtdLinhas}
                    qtdRegistros = {clienteFiltrado.length} 
                  />
                </div>
              )}
            </div>
          </section>
        </main>

        <Rodape versao={Globais.versao}/>
      </div>
    );
  }
  